import React, { useMemo } from 'react';
import '../../styles/Statistics.css';
import { Eye, TrendingDown, Zap, Target } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

interface Statistic {
  icon: React.ReactNode;
  value: number;
  suffix: string;
  label: string;
  prefix?: string;
}

const Statistics: React.FC = () => {
  const { t } = useLanguage();

  const statistics: Statistic[] = useMemo(() => [
    {
      icon: <Eye className="w-8 h-8" />,
      value: 100,
      suffix: '%',
      label: t('benefits.realtime.title'),
      prefix: ''
    },
    {
      icon: <TrendingDown className="w-8 h-8" />,
      value: 30,
      suffix: '%',
      label: t('benefits.cost.title')
    },
    {
      icon: <Zap className="w-8 h-8" />,
      value: 24,
      suffix: '/7',
      label: t('benefits.efficiency.title')
    },
    {
      icon: <Target className="w-8 h-8" />,
      value: 95,
      suffix: '%',
      label: t('benefits.improvement.title')
    }
  ], [t]);

  return (
    <section id="benefits" className="statistics">
      <div className="container">
        <div className="section-header">
          <h2>{t('benefits.title')}</h2>
          <p>
            {t('benefits.description')}
          </p>
        </div>

        <div className="stats-grid">
          {statistics.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">
                {stat.icon}
              </div>
              
              <div className="stat-value">
                {stat.prefix}
                {stat.value}
                {stat.suffix}
              </div>
              
              <p className="stat-label">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        <div className="achievements-card">
          <h3>{t('benefits.impact.title')}</h3>
          <div className="achievements-grid">
            <div className="achievement-item">
              <div className="achievement-value">{t('benefits.impact.security.icon')}</div>
              <p>{t('benefits.impact.security.text')}</p>
            </div>
            <div className="achievement-item">
              <div className="achievement-value">{t('benefits.impact.assets.icon')}</div>
              <p>{t('benefits.impact.assets.text')}</p>
            </div>
            <div className="achievement-item">
              <div className="achievement-value">{t('benefits.impact.decisions.icon')}</div>
              <p>{t('benefits.impact.decisions.text')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;